import { FieldConfig } from 'src/app/interfaces/field.interface';
import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule  } from "@angular/forms";

@Component({
  selector: "app-input",
  template: `
  <br>
<mat-form-field class="demo-full-width" [formGroup]="group">
<input matInput [formControlName]="field.name" [placeholder]="field.label" [type]="field.inputType">
<ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
<mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
</ng-container>
</mat-form-field>
`,
  styles: []
})
export class InputComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
